module.exports = __webpack_public_path__ + "static/2-e93008d788a5bb296b40f67d49250d84.jpg";